module.exports = __webpack_public_path__ + "img/6554694.b0f77ae7.png";